
import { Link } from 'react-router-dom';

const plans = [
  { name: 'Launch', limit: '$10,000', price: '$959' },
  { name: 'Shuttle', limit: '$20,000', price: '$1,279' },
  { name: 'Throttle', limit: '$30,000', price: '$1,599' },
  { name: 'Astro', limit: '$40,000', price: '$1,919' },
  { name: 'Orbit', limit: '$50,000', price: '$2,239' },
  { name: 'Galactic', limit: '$60,000', price: '$2,559' },
  { name: 'Thruster', limit: '$70,000', price: '$2,879' },
  { name: 'Turbo', limit: '$80,000', price: '$3,199' },
  { name: 'Mach 5', limit: '$90,000', price: '$3,519' },
  { name: 'Rocket', limit: '$100,000', price: '$3,839' },
  { name: 'Lightspeed', limit: '$150,000', price: '$5,119' },
];

export default function ServerLeasePricing() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-wider text-gray-600 mb-4 font-semibold">
            PRICING
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6">
            Server Lease Builder – Business Tradelines
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Choose the plan that fits your business credit goals. All plans include cloud server access and reporting to business credit bureaus.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {plans.map((plan, index) => {
            const isTop = plan.name === 'Lightspeed';
            return (
              <div
                key={index}
                className={`relative rounded-xl border p-6 flex flex-col transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${
                  isTop
                    ? 'border-navy bg-navy text-white shadow-lg'
                    : 'border-gray-200 bg-white hover:border-navy/30'
                }`}
              >
                {isTop && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-white text-navy text-xs font-bold uppercase tracking-wider px-4 py-1 rounded-full shadow whitespace-nowrap">
                    Top Tier
                  </span>
                )}

                <h3 className={`text-xl font-bold mb-1 ${isTop ? 'text-white' : 'text-navy'}`}>
                  {plan.name}
                </h3>

                <p className={`text-sm mb-5 ${isTop ? 'text-gray-300' : 'text-gray-500'}`}>
                  {plan.limit} Limit
                </p>

                <div className="space-y-3 mb-6 flex-1">
                  <div className="flex items-center gap-2.5">
                    <div className={`w-5 h-5 flex items-center justify-center ${isTop ? 'text-white' : 'text-navy'}`}>
                      <i className="ri-cloud-line text-base"></i>
                    </div>
                    <span className={`text-sm ${isTop ? 'text-gray-200' : 'text-gray-700'}`}>
                      Cloud Server
                    </span>
                  </div>
                  <div className="flex items-center gap-2.5">
                    <div className={`w-5 h-5 flex items-center justify-center ${isTop ? 'text-white' : 'text-navy'}`}>
                      <i className="ri-file-chart-line text-base"></i>
                    </div>
                    <span className={`text-sm ${isTop ? 'text-gray-200' : 'text-gray-700'}`}>
                      Reports to bureaus
                    </span>
                  </div>
                </div>

                <div className={`border-t pt-5 mb-5 ${isTop ? 'border-white/20' : 'border-gray-100'}`}>
                  <p className={`text-xs uppercase tracking-wider mb-1 ${isTop ? 'text-gray-400' : 'text-gray-500'}`}>
                    Set Up
                  </p>
                  <p className={`text-3xl font-bold ${isTop ? 'text-white' : 'text-navy'}`}>
                    {plan.price}
                  </p>
                </div>

                <Link
                  to="/apply"
                  className={`inline-flex items-center justify-center px-6 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isTop
                      ? 'bg-white text-navy hover:bg-gray-100'
                      : 'bg-navy text-white hover:bg-navy/90'
                  }`}
                >
                  Apply
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
